var MarkerFactory = require('./MarkerFactory');
var OverlayPanel = require('./OverlayPanel');
var $ = require('jquery');

/**
 * Controller of nearby attraction markers and overlay panel
 * @constructor
 * @param {Object} map - google.maps.Map object
 * @param {Array} nearByDetails - array of nearby attraction details
 * @param {Object} $overlayPanel - jQuery wrapped overlay panel element
 * @param {Object} google - Google maps API
 */
function MarkerGroup(map, nearByDetails, $overlayPanel, google) {
  this.map = map;
  this.nearByDetails = nearByDetails;
  this.markers = [];
  this.locations = [];
  this.activeMarker = null;
  this.init($overlayPanel, google);
}

/**
 * Initialize nearby point of interest markers
 * @param {Object} $overlayPanel - jQuery wrapped overlay panel element
 * @param {Object} google - Google maps API
 * @return {void}
 */
MarkerGroup.prototype.init = function ($overlayPanel, google) {
  var _self = this;
  this.locationBounds = new google.maps.LatLngBounds();
  this.markers = this.nearByDetails.map(function (nearByDetails) {
    var brandMarker = MarkerFactory.createNearbyMarker(new google.maps.OverlayView(),
      nearByDetails.location,
      _self, nearByDetails);
    brandMarker.setMap(_self.map);
    _self.locations.push(nearByDetails.location);
    _self.locationBounds.extend(nearByDetails.location);
  });
  this.overlayPanel = new OverlayPanel(this, $overlayPanel);
};

/**
 * Clear active marker
 * @return {void}
 */
MarkerGroup.prototype.clear = function () {
  if( this.activeMarker ){
    this.activeMarker.clear();
  }
};

/**
 * Toggle state of marker
 * @param {Object} marker - Map pin representing nearby property location.
 * @return {void}
 */
MarkerGroup.prototype.toggleMarker = function (marker) {
  if( marker.isActive() ){
   this.clearMarker();
   this.overlayPanel.hide();
  } else {
    this.activateMarker(marker);
    this.overlayPanel.show(marker.getDetails());
  }
};

/**
 * Toggle state of active marker
 * @return {void}
 */
MarkerGroup.prototype.toggleActiveMarker = function () {
  if( this.activeMarker ){
    this.toggleMarker(this.activeMarker);
  }
};

/**
 * Get south-west and north-east bounds of markers
 * @return {Object} google.maps.LatLngBounds coordinates representing the south-west and north-east corners of markers
 */
MarkerGroup.prototype.getMarkerBounds = function () {
  return this.locationBounds;
};

/**
 * Get nearby attraction locations
 * @return {Array} array of google.maps.LatLng coordinates representing nearby attraction location
 */
MarkerGroup.prototype.getLocations = function () {
  return this.locations;
};

/**
 * Activate marker state
 * @param {Object} marker - Map pin representing nearby property location.
 * @return {void}
 */
MarkerGroup.prototype.activateMarker = function (marker) {
  if( this.activeMarker ){
    this.activeMarker.clear();
  }
  this.activeMarker = marker;
  this.activeMarker.activate();
};

/**
 * Clear active marker
 * @return {void}
 */
MarkerGroup.prototype.clearMarker = function () {
  this.activeMarker.clear();
  this.activeMarker = null;
};

module.exports = MarkerGroup;

